import React from 'react';

const BasicLayout: React.FC = ({ children }) => {
    return <>{children}</>;
};

export default BasicLayout;
